/** Base browser-tab title; keep in sync with <title> in index.html. */
export const APP_TITLE = 'SafeZone';

/** Browser-tab title: the base title, plus the selected case name when there is one. */
export function buildDocumentTitle(caseName: string | null | undefined): string {
  const name = caseName?.trim();
  return name ? `${APP_TITLE} – ${name}` : APP_TITLE;
}
